<template>
	 <div class="content-wapper">
		<el-row class="navigation">
		    <el-col align="left">
		        <el-breadcrumb separator-class="el-icon-arrow-right">
		            <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
		            <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
		            <el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>
		            <el-breadcrumb-item>京鲁慧一键通览</el-breadcrumb-item>
		        </el-breadcrumb>
		     </el-col>
		</el-row>
		<div class="search-where">
			<div class="search-item">
			    <div class="search-item-left">
			        服务类别：
			    </div>
			    <div class="search-item-right" style="color: #303133;">
					<el-button class="item-right-select-ly" v-for="(item,index) in fwlxList" :key="index" :class="index==active?'font-blue':''"  @click="handleFwlxField(item.fwlxName);change(index)" >
					    {{item.fwlxName}}
					</el-button>
			    </div>
			</div>
			<div class="search-item">
				<div style="line-height:40px;margin-top: 30px;">
					<div style="text-align: left;color: #333333;">功能介绍：{{this.fwlxContent}}</div>
				</div>
			</div>
		</div>
		<el-row>
			<el-col :span="8" style="height: 170px;padding: 0 15px 10px ;" v-for="sx in sxglList" >
				<div style="background-color: #FAFAFA;height: 100%;cursor:pointer" @click="openNewPage(sx.fwUrl)">
						<div style="height:5px ;"/>
						<div style="margin-top: 10px;color:deepskyblue;font-weight:bolder;color: #5BAAEB;">
							{{sx.sxName}}
						</div>
						<div style="margin-top: 10px;padding: 0 15px 0;color: #666666;text-align: left;text-indent: 2em;">{{sx.fwContent}}</div>
				</div>
			</el-col>
		</el-row>
	 </div>
</template>

<script>
	import { listJlhFwlx,listJlhSxgl } from "@/api/zscq/jlhyjtl";
	import {updatePvNum} from "@/api/itempv/pv";
	
	export default {
	    name: "jlhyjtl",
	    data() {
	        return {
	            // 遮罩层
	            loading: true,
	            // 服务类型总条数
	            fwlxTotal: 0,
				// 事项总条数
				sxglTotal: 0,
	            // 表格数据
	            list: [],
				//服务类型数据
				fwlxList: [],
				//事项管理数据
				sxglList: [],
	            // 查询参数
	            queryParams: {
	                pageNum: 1,
	                pageSize: 10,
	                fwlxName:undefined,
	            },
				fwlxParams:{},
	            fwlxContent:undefined,
	            sxglOptions:[],
				active:0,
	        };
	    },
	    created() {
	        this.getList();
	        updatePvNum("zscq_jlhyjtl").then(response => {
	            //pv 点击京鲁慧一键通览
	        });
	    },
	    methods: {
	        getList(){
				this.sxglList = undefined;
				this.fwlxFunction = undefined;
	            this.loading = true;
				// 获取服务类型所有选项
	            listJlhFwlx(this.fwlxParams).then(response => {
	                this.fwlxList = response.rows;
	                this.fwlxTotal = response.total;
	                // console.log(this.fwlxList)
	            });
				//针对已选择选项返回服务类型的功能介绍
				listJlhFwlx(this.queryParams).then(response =>{
					let functions = response.rows;
					// console.log(functions[0])
					this.fwlxContent = functions[0].fwlxFunction;
					// console.log(functions[0].fwlxFunction)
				});
				// 返回指定服务类型的事项
				listJlhSxgl(this.queryParams).then(response =>{
					this.sxglList = response.rows;
					this.sxglTotal = response.total;
					// console.log(this.sxglList)
				});
	        },
			// 传值给参数列表进行查询
			handleFwlxField(code){
			    this.queryParams.fwlxName=code;
			    this.getList();
			},
			// 更改默认显示
			change(index){
				this.active = index;
				// console.log(index)
			},
			// 点击div打开网页
			openNewPage(url) {
				// alert(url)
				if(url !=null && url!="" && url!=undefined){
					this.utils.windowOpen(url);
				}
			},
	    },
	}

</script>

<style scoped>
	.content-wapper{
	    margin-top: 5px;
	    padding: 10px;
	}
	.navigation{
	    padding:20px 15px;
	    line-height: 20px;
	    height: 60px;
	    background-color: #F5F5F5;
	    margin-bottom: 15px;
	}
	.search-where{
	    margin: 10px 0px;
	    padding: 15px;
	    background-color: #ffffff;
	}
	.search-item{
	    display: flex;
	    /*border-bottom: 1px solid #000000;*/
	}
	.search-item-left{
	    line-height: 40px;
	    font-weight: bold;
	}
	.search-item-right{
	    flex: 1;
	    padding: 0px 10px;
	}
	.item-right-select-ly{
        float: left;
        /*width: 85px;*/
        padding: 5px 10px;
        line-height: 30px;
        /*border: 1px solid #000000;*/
	}
	.font-blue{
	    color: #409EFF;
	}
	.el-button{
		border: 0px;
	}
	/deep/.el-button:focus, .el-button:hover{
		color: #409eff;
		border-color: #fff;
		background-color: #fff;
	}
</style>